module.exports = __webpack_public_path__ + "img/2.35313740.png";